import QuestionReview from "../../components/fun_stuff/QuestionReview";
import QuizHeader from "../../components/fun_stuff/QuizHeader";
import UpdateInfo from "../../components/fun_stuff/UpdateInfo";

const QuizAdminScreen = () => {
    return (
        <>
        <QuizHeader />
        <UpdateInfo admin={true} />
        <QuestionReview />
        </>
    )
}

export default QuizAdminScreen